import isPromise from '@insight/toolkit-utils/lib/types/basic/isPromise';

import clearAsyncValidationPromises from './clearAsyncValidationPromises';

const validateRecord = (state, setErrors) => {
  const { asyncValidationPromises, config, formState } = state;
  const promises = [];

  if (config.validate) {
    const errorsOrPromise = config.validate({ ...formState.values });
    if (isPromise(errorsOrPromise)) {
      const asyncValidationKey = state.nextAsyncValidationKey++;
      const promise = errorsOrPromise
        .then(setErrors)
        .then(clearAsyncValidationPromises(asyncValidationKey));
      promises.push(promise);
      asyncValidationPromises[asyncValidationKey] = promise;
    } else {
      setErrors(errorsOrPromise);
    }
  }

  return promises;
};

export default validateRecord;
